import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

import { urlEndPoints } from '../config/end-points';
import { Hospital } from '../models/hospital.model';

@Injectable({
  providedIn: 'root',
})
export class HospitalDal {
  constructor(private httpClient: HttpClient) {}

  editIsBlockedOneHospital(hospitalId: string, isBlocked: boolean): Observable<Hospital> {
    return this.httpClient.put<any>(urlEndPoints.hospitals + 'editIsBlockedOneHospital/' + hospitalId, { isBlocked });
  }

  getHospital(hospitalId?: string): Observable<Hospital> {
    return this.httpClient.get<Hospital>(urlEndPoints.hospitals + (hospitalId ? hospitalId : ''));
  }

  getHospitalsByHospitalName(hospitalName: string): Observable<Hospital[]> {
    return this.httpClient.get<Hospital[]>(urlEndPoints.hospitals + 'by/' + hospitalName);
  }

  modifyHospital(hospital: Hospital): Observable<Hospital> {
    return this.httpClient.put<Hospital>(urlEndPoints.hospitals + hospital._id, hospital);
  }

  updateNursesAutofillingSettings(args: { hospitalId: string; nursesAutofillingSettings: any }): Observable<Hospital> {
    return this.httpClient.put<Hospital>(
      `${urlEndPoints.hospitals}updateNursesAutofillingSettings/${args.hospitalId}`,
      args.nursesAutofillingSettings
    );
  }

  updateAnesthsAutofillingSettings(args: {
    hospitalId: string;
    anesthsAutofillingSettings: any;
  }): Observable<Hospital> {
    return this.httpClient.put<Hospital>(
      `${urlEndPoints.hospitals}updateAnesthsAutofillingSettings/${args.hospitalId}`,
      args.anesthsAutofillingSettings
    );
  }

  updateIadesAutofillingSettings(args: { hospitalId: string; iadesAutofillingSettings: any }): Observable<Hospital> {
    return this.httpClient.put<Hospital>(
      `${urlEndPoints.hospitals}updateIadesAutofillingSettings/${args.hospitalId}`,
      args.iadesAutofillingSettings
    );
  }

  updateAutofillingSettings(args: { hospitalId: string; autofillingSettings: any }): Observable<Hospital> {
    return this.httpClient.put<Hospital>(
      `${urlEndPoints.hospitals}updateAutofillingSettings/${args.hospitalId}`,
      args.autofillingSettings
    );
  }

  checkCompatibility(): Observable<any> {
    return this.httpClient.get<any>(`${urlEndPoints.hospitals}checkCompatibility`);
  }

  editCycleHospital(hospitalId: string, data: object): Observable<any> {
    return this.httpClient.put<any>(urlEndPoints.hospitals + 'editCycleHospital/' + hospitalId, { data });
  }

  getHospitalIndicators() {
    return this.httpClient.get<any>(urlEndPoints.hospitals + 'getHospitalIndicators');
  }

  updateHospitalInfos(hospitalId: string, logoUrl: string): Observable<Hospital> {
    return this.httpClient.put<any>(urlEndPoints.hospitals + hospitalId, logoUrl);
  }
}
